import Tick from "@pqina/flip";

((Drupal, drupalSettings) => {
  Drupal.behaviors.wwf_paragraph_countdown = {
    attach(context) {
      const toks = once("wwf_paragraph_countdown", ".tick", context);
      toks.forEach((element) => {
        Tick.DOM.create(element, {
          credits: false,
          didInit(tick) {
            const date = String(tick._element.getAttribute("data-value"));
            const counter = Tick.count.down(date);
            let paragraphId = Array.from(element.classList.values()).find(
              (item) => {
                return item.contains("countdown-");
              }
            );
            if (paragraphId) {
              paragraphId = paragraphId.replace("countdown-", "");
            }
            counter.onupdate = (value) => {
              tick.value = value;
            };

            counter.onended = () => {
              console.log("ended");
              const parent = element.parentElement;
              const shouldStayOnPage =
                drupalSettings.paragraph_countdown[paragraphId]
                  .should_clock_stay_on_page;
              const messageElement = parent.querySelector(".outdated_message");
              if (shouldStayOnPage === false && messageElement === null) {
                parent.classList.add("hidden");
              } else if (shouldStayOnPage === false && messageElement) {
                parent.querySelector(".tick").classList.add("hidden");
                messageElement.classList.remove("hidden");
              }
            };
          },
        });
      });
    },
  };
})(Drupal, drupalSettings);
